import { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { showError, showSuccess } from '../utils/alerts';
import '../styles/components/Login.css';

const AdminLogin = ({ onLoginSuccess }) => {
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Login de admin - NO usa JWT, usa sesiones
      const response = await axios.post(
        `${API_BASE_URL}/api/admin/login`,
        { correo, password },
        {
          withCredentials: true // IMPORTANTE: enviar y recibir cookies
        }
      );

      console.log('✅ Login admin exitoso:', response.data);
      showSuccess('Bienvenido ' + response.data.admin.nombre);

      // Guardar datos del admin en sessionStorage (opcional, para UI)
      sessionStorage.setItem('adminData', JSON.stringify(response.data.admin));

      // Llamar callback de éxito
      if (onLoginSuccess) {
        onLoginSuccess(response.data.admin);
      }

    } catch (error) {
      console.error('❌ Error en login admin:', error);
      const errorMessage = error.response?.data?.message || 'Error al iniciar sesión';
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>
            <span className="taxi-highlight">TⒶXí</span> Administrador
          </h2>
          <p>Panel de administración</p>

          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            placeholder="Correo"
            required
            disabled={loading}
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            required
            disabled={loading}
          />

          <button type="submit" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Ingresar'}
          </button>

          <div className="login-info">
            <small>🔒 Sesión segura con cookies HttpOnly</small>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
